import Product from "../../../../../@types/Product";
import SelectOption from "../../../../../@types/SelectOption";
import LugNuts from "../../Shared/LugNuts";

const ChromeLugnut = LugNuts[0];
const BlkLugnut = LugNuts[1];

const WheelSizeOptions: SelectOption[] = [
    { label: `12"`, value: 12, disabled: false, disabledMessage: '' },
    { label: `14"`, value: 14, disabled: false, disabledMessage: '' },
    { label: `15"`, value: 15, disabled: false, disabledMessage: '| only available with lift kit' },
]

const Wheels12InX2: Product[] = [
    {
        id: 1,
        refId: 12,
        name: '12" GTW Specter - Chrome x4',
        sku: '19-189',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/12-inch/gtw-12-specter-chrome-300x300.jpg`,
        price: 360,
        retailPrice: 200.00,
        linkedProducts: [ChromeLugnut],
        configuratorImg: 'https://madjax.com/wp-content/uploads/2023/08/wheels-specter-12-in-chrome-web-sized.png',
        visible: false
    },
    {
        id: 2,
        refId: 12,
        name: '12" GTW Spyder - Black with Machined Accents x4',
        sku: '19-218',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/12-inch/gtw-12-spyder-blackmachined-300x300.jpg`,
        price: 220.00,
        retailPrice: 0.00,
        linkedProducts: [ChromeLugnut],
        configuratorImg: 'https://madjax.com/wp-content/uploads/2023/08/wheels-spyder-12-in-black-with-machined-accents-web-sized-1.png'
    },
    {
        id: 3,
        refId: 12,
        name: '12" GTW Spyder - Matte Black x4',
        sku: '19-246',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/12-inch/gtw-12-spyder-matteblack-300x300.jpg`,
        price: 240.00,
        retailPrice: 0.00,
        linkedProducts: [BlkLugnut],
        configuratorImg: 'https://madjax.com/wp-content/uploads/2023/08/wheels-spyder-12-in-matte-black-web-sized.png',
        visible: false
    },
    {
        id: 4,
        refId: 12,
        name: '12" GTW Spyder - Matte Gray x4',
        sku: '19-255',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/12-inch/gtw-12-spyder-mattegray-1-300x300.jpg`,
        price: 240.00,
        retailPrice: 0.00,
        linkedProducts: [BlkLugnut],
        configuratorImg: 'https://madjax.com/wp-content/uploads/2023/08/wheels-spyder-12-in-matte-gray-web-sized.png'
    },
    {
        id: 5,
        refId: 12,
        name: '12" GTW Vortex 2 - Matte Black x4',
        sku: '19-232',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/12-inch/gtw-12-vortex-matteblack-300x300.jpg`,
        price: 240.00,
        retailPrice: 0.00,
        linkedProducts: [BlkLugnut],
        configuratorImg: 'https://madjax.com/wp-content/uploads/2023/08/wheels-vortex-12-in-matte-black-web-sized.png'
    },
    {
        id: 6,
        refId: 12,
        name: '12" GTW Omega - Black with Machined Accents x4',
        sku: '19-260',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/12-inch/gtw-12-omega-black-300x300.jpg`,
        price: 240.00,
        retailPrice: 0.00,
        linkedProducts: [ChromeLugnut],
        configuratorImg: 'https://madjax.com/wp-content/uploads/2023/08/wheels-omega-12-in-machined-black-web-sized.png'
    },
]

const Wheels12InLiftedX2: Product[] = [
    {
        id: 1,
        refId: 12,
        name: '12" GTW Specter - Chrome x4',
        sku: '19-189',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/12-inch/gtw-12-specter-chrome-300x300.jpg`,
        price: 360,
        retailPrice: 200.00,
        linkedProducts: [ChromeLugnut],
        configuratorImg: 'https://madjax.com/wp-content/uploads/2023/08/wheels-lifted-specter-12-in-chrome-web-sized.png',
        visible: false
    },
    {
        id: 2,
        refId: 12,
        name: '12" GTW Spyder - Black with Machined Accents x4',
        sku: '19-218',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/12-inch/gtw-12-spyder-blackmachined-300x300.jpg`,
        price: 220.00,
        retailPrice: 0.00,
        linkedProducts: [ChromeLugnut],
        configuratorImg: 'https://madjax.com/wp-content/uploads/2023/08/wheels-lifted-spyder-12-in-black-with-machined-accents-web-sized.png'
    },
    {
        id: 3,
        refId: 12,
        name: '12" GTW Spyder - Matte Black x4',
        sku: '19-246',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/12-inch/gtw-12-spyder-matteblack-300x300.jpg`,
        price: 240.00,
        retailPrice: 0.00,
        linkedProducts: [BlkLugnut],
        configuratorImg: 'https://madjax.com/wp-content/uploads/2023/08/wheels-lifted-spyder-12-in-matte-black-web-sized.png',
        visible: false
    },
    {
        id: 4,
        refId: 12,
        name: '12" GTW Spyder - Matte Gray x4',
        sku: '19-255',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/12-inch/gtw-12-spyder-mattegray-1-300x300.jpg`,
        price: 240.00,
        retailPrice: 0.00,
        linkedProducts: [BlkLugnut],
        configuratorImg: 'https://madjax.com/wp-content/uploads/2023/08/wheels-lifted-spyder-12-in-matte-gray-web-sized.png'
    },
    {
        id: 5,
        refId: 12,
        name: '12" GTW Vortex 2 - Matte Black x4',
        sku: '19-232',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/12-inch/gtw-12-vortex-matteblack-300x300.jpg`,
        price: 240.00,
        retailPrice: 0.00,
        linkedProducts: [BlkLugnut],
        configuratorImg: 'https://madjax.com/wp-content/uploads/2023/08/wheels-lifted-vortex-12-in-matte-black-web-sized.png'
    },
    {
        id: 6,
        refId: 12,
        name: '12" GTW Omega - Black with Machined Accents x4',
        sku: '19-260',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/12-inch/gtw-12-omega-black-300x300.jpg`,
        price: 240.00,
        retailPrice: 0.00,
        linkedProducts: [ChromeLugnut],
        configuratorImg: 'https://madjax.com/wp-content/uploads/2023/08/wheels-lifted-omega-12-in-machined-black-web-sized.png'
    },
]

const Wheels14InX2: Product[] = [
    {
        id: 7,
        refId: 14,
        name: '14" GTW Specter - Chrome x4',
        sku: '19-190',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/14-inch/gtw-14-specter-chrome-1-300x300.jpg`,
        price: 440.00,
        retailPrice: 330.00,
        linkedProducts: [ChromeLugnut],
        configuratorImg: 'https://madjax.com/wp-content/uploads/2023/08/wheels-specter-14-in-chrome-web-sized.png'
    },
    {
        id: 8,
        refId: 14,
        name: '14" GTW Spyder - Black with Machined Accents x4',
        sku: '19-221',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/14-inch/gtw-14-spyder-blackmachined-300x300.jpg`,
        price: 280.00,
        retailPrice: 150.00,
        linkedProducts: [ChromeLugnut],
        configuratorImg: 'https://madjax.com/wp-content/uploads/2023/08/wheels-spyder-14-in-black-with-machined-accents-web-sized.png',
        visible: false
    },
    {
        id: 9,
        refId: 14,
        name: '14" GTW Spyder - Matte Black x4',
        sku: '19-245',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/14-inch/gtw-14-spyder-matteblack-1-300x300.jpg`,
        price: 320.00,
        retailPrice: 150.00,
        linkedProducts: [BlkLugnut],
        configuratorImg: 'https://madjax.com/wp-content/uploads/2023/08/wheels-spyder-14-in-matte-black-web-sized.png',
        visible: false
    },
    {
        id: 10,
        refId: 14,
        name: '14" GTW Spyder - Matte Gray x4',
        sku: '19-253',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/14-inch/gtw-14-spyder-matteblack-1-300x300.jpg`,
        price: 320.00,
        retailPrice: 150.00,
        linkedProducts: [BlkLugnut],
        configuratorImg: 'https://madjax.com/wp-content/uploads/2023/08/wheels-spyder-14-in-matte-gray-web-sized.png'
    },
    {
        id: 11,
        refId: 14,
        name: '14" GTW Bravo - Matte Bronze x4',
        sku: '19-224',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/14-inch/gtw-14-bravo-bronze-300x300.jpg`,
        price: 320.00,
        retailPrice: 150.00,
        linkedProducts: [BlkLugnut],
        configuratorImg: 'https://madjax.com/wp-content/uploads/2023/08/wheels-bravo-14-in-matte-bronze-web-sized.png'
    },
    {
        id: 12,
        refId: 14,
        name: '14" GTW Bravo - Matte Gray x4',
        sku: '19-225',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/14-inch/gtw-14-bravo-mattegray-1-300x300.jpg`,
        price: 320.00,
        retailPrice: 150.00,
        linkedProducts: [BlkLugnut],
        configuratorImg: 'https://madjax.com/wp-content/uploads/2023/08/wheels-bravo-14-in-matte-gray-web-sized.png'
    },
    {
        id: 13,
        refId: 14,
        name: '14" GTW Bravo - Matte Black x4',
        sku: '19-251',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/14-inch/gtw-14-bravo-matteblack-1-300x300.jpg`,
        price: 320.00,
        retailPrice: 150.00,
        linkedProducts: [BlkLugnut],
        configuratorImg: 'https://madjax.com/wp-content/uploads/2023/08/wheels-bravo-14-in-matte-black-web-sized.png',
        visible: false
    },
    {
        id: 14,
        refId: 14,
        name: '14" GTW Raven - Matte Black with Ball Mill x4',
        sku: '19-226',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/14-inch/gtw-14-raven-blackmachined-300x300.jpg`,
        price: 320.00,
        retailPrice: 150.00,
        linkedProducts: [BlkLugnut],
        configuratorImg: 'https://madjax.com/wp-content/uploads/2023/08/wheels-raven-14-in-matte-black-with-ball-mill-web-sized.png',
        visible: false
    },
    {
        id: 15,
        refId: 14,
        name: '14" GTW Vortex 2 - Matte Black x4',
        sku: '19-229',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/14-inch/gtw-14-vortex-blackmatte-300x300.jpg`,
        price: 320.00,
        retailPrice: 150.00,
        linkedProducts: [BlkLugnut],
        configuratorImg: 'https://madjax.com/wp-content/uploads/2023/08/wheels-vortex-14-in-matte-black-web-sized.png',
        visible: false
    },
    {
        id: 16,
        refId: 14,
        name: '14" GTW Vortex 2 - Matte Black with Machined Accent x4',
        sku: '19-230',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/14-inch/gtw-14-vortex-blackmachined-1-300x300.jpg`,
        price: 280.00,
        retailPrice: 150.00,
        linkedProducts: [ChromeLugnut],
        configuratorImg: 'https://madjax.com/wp-content/uploads/2023/08/wheels-vortex-14-in-matte-black-with-machined-accents-web-sized.png'
    },
]

const Wheels14InLiftedX2: Product[] = [
    {
        id: 7,
        refId: 14,
        name: '14" GTW Specter - Chrome x4',
        sku: '19-190',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/14-inch/gtw-14-specter-chrome-1-300x300.jpg`,
        price: 440.00,
        retailPrice: 330.00,
        linkedProducts: [ChromeLugnut],
        configuratorImg: 'https://madjax.com/wp-content/uploads/2023/08/wheels-lifted-specter-14-in-chrome-web-sized.png'
    },
    {
        id: 8,
        refId: 14,
        name: '14" GTW Spyder - Black with Machined Accents x4',
        sku: '19-221',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/14-inch/gtw-14-spyder-blackmachined-300x300.jpg`,
        price: 280.00,
        retailPrice: 150.00,
        linkedProducts: [ChromeLugnut],
        configuratorImg: 'https://madjax.com/wp-content/uploads/2023/08/wheels-lifted-spyder-14-in-black-with-machined-accents-web-sized.png',
        visible: false
    },
    {
        id: 9,
        refId: 14,
        name: '14" GTW Spyder - Matte Black x4',
        sku: '19-245',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/14-inch/gtw-14-spyder-matteblack-1-300x300.jpg`,
        price: 320.00,
        retailPrice: 150.00,
        linkedProducts: [BlkLugnut],
        configuratorImg: 'https://madjax.com/wp-content/uploads/2023/08/14-spyder-matte-black-lifted-1.png',
        visible: false
    },
    {
        id: 10,
        refId: 14,
        name: '14" GTW Spyder - Matte Gray x4',
        sku: '19-253',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/14-inch/gtw-14-spyder-matteblack-1-300x300.jpg`,
        price: 320.00,
        retailPrice: 150.00,
        linkedProducts: [BlkLugnut],
        configuratorImg: 'https://madjax.com/wp-content/uploads/2023/08/wheels-lifted-spyder-14-in-matte-gray-web-sized.png'
    },
    {
        id: 11,
        refId: 14,
        name: '14" GTW Bravo - Matte Bronze x4',
        sku: '19-224',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/14-inch/gtw-14-bravo-bronze-300x300.jpg`,
        price: 320.00,
        retailPrice: 150.00,
        linkedProducts: [BlkLugnut],
        configuratorImg: 'https://madjax.com/wp-content/uploads/2023/08/wheels-lifted-bravo-14-in-matte-bronze-web-sized.png'
    },
    {
        id: 12,
        refId: 14,
        name: '14" GTW Bravo - Matte Gray x4',
        sku: '19-225',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/14-inch/gtw-14-bravo-mattegray-1-300x300.jpg`,
        price: 320.00,
        retailPrice: 150.00,
        linkedProducts: [BlkLugnut],
        configuratorImg: 'https://madjax.com/wp-content/uploads/2023/08/wheels-lifted-bravo-14-in-matte-gray-web-sized.png'
    },
    {
        id: 13,
        refId: 14,
        name: '14" GTW Bravo - Matte Black x4',
        sku: '19-251',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/14-inch/gtw-14-bravo-matteblack-1-300x300.jpg`,
        price: 320.00,
        retailPrice: 150.00,
        linkedProducts: [BlkLugnut],
        configuratorImg: 'https://madjax.com/wp-content/uploads/2023/08/wheels-lifted-bravo-14-in-matte-black-web-sized.png',
        visible: false
    },
    {
        id: 14,
        refId: 14,
        name: '14" GTW Raven - Matte Black with Ball Mill x4',
        sku: '19-226',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/14-inch/gtw-14-raven-blackmachined-300x300.jpg`,
        price: 320.00,
        retailPrice: 150.00,
        linkedProducts: [BlkLugnut],
        configuratorImg: 'https://madjax.com/wp-content/uploads/2023/08/wheels-lifted-raven-14-in-matte-black-with-ball-mill-web-sized.png',
        visible: false
    },
    {
        id: 15,
        refId: 14,
        name: '14" GTW Vortex 2 - Matte Black x4',
        sku: '19-229',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/14-inch/gtw-14-vortex-blackmatte-300x300.jpg`,
        price: 320.00,
        retailPrice: 150.00,
        linkedProducts: [BlkLugnut],
        configuratorImg: 'https://madjax.com/wp-content/uploads/2023/08/wheels-lifted-vortex-14-in-matte-black-web-sized.png',
        visible: false
    },
    {
        id: 16,
        refId: 14,
        name: '14" GTW Vortex 2 - Matte Black with Machined Accent x4',
        sku: '19-230',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/14-inch/gtw-14-vortex-blackmachined-1-300x300.jpg`,
        price: 280.00,
        retailPrice: 150.00,
        linkedProducts: [ChromeLugnut],
        configuratorImg: 'https://madjax.com/wp-content/uploads/2023/08/wheels-lifted-vortex-14-in-matte-black-with-machined-accents-web-sized.png'
    },
]

const Wheels15InX2: Product[] = [
    {
        id: 17,
        refId: 15,
        name: '15" MadJax® Flow Form Evolution - Matte Black x4',
        sku: '19-262',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/15-inch/madjax-15-flowform-matteblack-300x300.jpg`,
        price: 360.00,
        retailPrice: 260.00,
        linkedProducts: [BlkLugnut]
    },
    {
        id: 18,
        refId: 15,
        name: '15" MadJax® Flow Form Evolution - Gunmetal x4',
        sku: '19-264',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/15-inch/madjax-15-flowform-gunmetal-300x300.jpg`,
        price: 360.00,
        retailPrice: 260.00,
        linkedProducts: [BlkLugnut]
    },
    {
        id: 19,
        refId: 15,
        name: '15" GTW Bravo - Matte Black x4',
        sku: '19-300',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/15-inch/gtw-15-bravo-matteblack-1-300x300.jpg`,
        price: 360.00,
        retailPrice: 260.00,
        linkedProducts: [BlkLugnut]
    },
    {
        id: 20,
        refId: 15,
        name: '15" GTW Bravo - Matte Gray x4',
        sku: '19-302',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/15-inch/gtw-15-bravo-mattegray-1-300x300.jpg`,
        price: 360.00,
        retailPrice: 260.00,
        linkedProducts: [BlkLugnut]
    },
    {
        id: 21,
        refId: 15,
        name: '15" GTW Spyder - Gloss Black with Machined Accents x4',
        sku: '19-306',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/15-inch/gtw-15-spyder-blackmachined-300x300.jpg`,
        price: 320.00,
        retailPrice: 260.00,
        linkedProducts: [ChromeLugnut]
    },
    {
        id: 22,
        refId: 15,
        name: '15" GTW Spyder - Matte Black x4',
        sku: '19-307',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/15-inch/gtw-15-spyder-matteblack-1-300x300.jpg`,
        price: 320.00,
        retailPrice: 260.00,
        linkedProducts: [BlkLugnut]
    },
]

const Wheels12InX4: Product[] = [
    {
        id: 1,
        refId: 12,
        name: '12" GTW Specter - Chrome x4',
        sku: '19-189',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/12-inch/gtw-12-specter-chrome-300x300.jpg`,
        price: 360,
        retailPrice: 200.00,
        linkedProducts: [ChromeLugnut],
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/a79eb9f0-a951-4898-0946-2a1ffb0bf000',
        visible: false
    },
    {
        id: 2,
        refId: 12,
        name: '12" GTW Spyder - Black with Machined Accents x4',
        sku: '19-218',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/12-inch/gtw-12-spyder-blackmachined-300x300.jpg`,
        price: 220.00,
        retailPrice: 0.00,
        linkedProducts: [ChromeLugnut],
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/ed38dbef-f155-4d2b-5222-e92fd7643700'
    },
    {
        id: 3,
        refId: 12,
        name: '12" GTW Spyder - Matte Black x4',
        sku: '19-246',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/12-inch/gtw-12-spyder-matteblack-300x300.jpg`,
        price: 240.00,
        retailPrice: 0.00,
        linkedProducts: [BlkLugnut],
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/e86cc7b4-5288-4cf6-5d17-21d9004f6c00',
        visible: false
    },
    {
        id: 4,
        refId: 12,
        name: '12" GTW Spyder - Matte Gray x4',
        sku: '19-255',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/12-inch/gtw-12-spyder-mattegray-1-300x300.jpg`,
        price: 240.00,
        retailPrice: 0.00,
        linkedProducts: [BlkLugnut],
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/f48b08b5-c368-4afe-89a3-48d9f7aa9400'
    },
    {
        id: 5,
        refId: 12,
        name: '12" GTW Vortex 2 - Matte Black x4',
        sku: '19-232',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/12-inch/gtw-12-vortex-matteblack-300x300.jpg`,
        price: 240.00,
        retailPrice: 0.00,
        linkedProducts: [BlkLugnut],
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/85522de2-9b3b-4b6b-9a66-f54ff0e5d100'
    },
    {
        id: 6,
        refId: 12,
        name: '12" GTW Omega - Black with Machined Accents x4',
        sku: '19-260',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/12-inch/gtw-12-omega-black-300x300.jpg`,
        price: 240.00,
        retailPrice: 0.00,
        linkedProducts: [ChromeLugnut],
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/e32b63f4-fad8-4a61-2d56-eebd4fa1ec00'
    },
]

const Wheels12InLiftedX4: Product[] = [
    {
        id: 1,
        refId: 12,
        name: '12" GTW Specter - Chrome x4',
        sku: '19-189',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/12-inch/gtw-12-specter-chrome-300x300.jpg`,
        price: 360,
        retailPrice: 200.00,
        linkedProducts: [ChromeLugnut],
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/14691363-b8fd-454e-8713-213ea6ad6500',
        visible: false
    },
    {
        id: 2,
        refId: 12,
        name: '12" GTW Spyder - Black with Machined Accents x4',
        sku: '19-218',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/12-inch/gtw-12-spyder-blackmachined-300x300.jpg`,
        price: 220.00,
        retailPrice: 0.00,
        linkedProducts: [ChromeLugnut],
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/93494962-1b36-4432-c453-38e07c400000'
    },
    {
        id: 3,
        refId: 12,
        name: '12" GTW Spyder - Matte Black x4',
        sku: '19-246',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/12-inch/gtw-12-spyder-matteblack-300x300.jpg`,
        price: 240.00,
        retailPrice: 0.00,
        linkedProducts: [BlkLugnut],
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/aecb72d4-958d-4ddb-b2a2-a3e14e7fa700',
        visible: false
    },
    {
        id: 4,
        refId: 12,
        name: '12" GTW Spyder - Matte Gray x4',
        sku: '19-255',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/12-inch/gtw-12-spyder-mattegray-1-300x300.jpg`,
        price: 240.00,
        retailPrice: 0.00,
        linkedProducts: [BlkLugnut],
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/037b73f8-342f-4b3a-263e-bdb1527e5d00'
    },
    {
        id: 5,
        refId: 12,
        name: '12" GTW Vortex 2 - Matte Black x4',
        sku: '19-232',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/12-inch/gtw-12-vortex-matteblack-300x300.jpg`,
        price: 240.00,
        retailPrice: 0.00,
        linkedProducts: [BlkLugnut],
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/aecb72d4-958d-4ddb-b2a2-a3e14e7fa700'
    },
    {
        id: 6,
        refId: 12,
        name: '12" GTW Omega - Black with Machined Accents x4',
        sku: '19-260',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/12-inch/gtw-12-omega-black-300x300.jpg`,
        price: 240.00,
        retailPrice: 0.00,
        linkedProducts: [ChromeLugnut],
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/c2f9bcfd-5caf-492a-27a2-b834487ca900'
    },
]

const Wheels14InX4: Product[] = [
    {
        id: 7,
        refId: 14,
        name: '14" GTW Specter - Chrome x4',
        sku: '19-190',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/14-inch/gtw-14-specter-chrome-1-300x300.jpg`,
        price: 440.00,
        retailPrice: 330.00,
        linkedProducts: [ChromeLugnut],
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/01b70a25-bbba-4320-4f32-8eeadac62500'
    },
    {
        id: 8,
        refId: 14,
        name: '14" GTW Spyder - Black with Machined Accents x4',
        sku: '19-221',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/14-inch/gtw-14-spyder-blackmachined-300x300.jpg`,
        price: 280.00,
        retailPrice: 150.00,
        linkedProducts: [ChromeLugnut],
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/674c4764-f5f5-4024-69f9-783b6e35ce00',
        visible: false
    },
    {
        id: 9,
        refId: 14,
        name: '14" GTW Spyder - Matte Black x4',
        sku: '19-245',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/14-inch/gtw-14-spyder-matteblack-1-300x300.jpg`,
        price: 320.00,
        retailPrice: 150.00,
        linkedProducts: [BlkLugnut],
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/78d0c406-6030-42c9-2e85-44d167e2d400',
        visible: false
    },
    {
        id: 10,
        refId: 14,
        name: '14" GTW Spyder - Matte Gray x4',
        sku: '19-253',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/14-inch/gtw-14-spyder-matteblack-1-300x300.jpg`,
        price: 320.00,
        retailPrice: 150.00,
        linkedProducts: [BlkLugnut],
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/9ad6f456-e9ab-4c99-95ec-bab9960d0c00'
    },
    {
        id: 11,
        refId: 14,
        name: '14" GTW Bravo - Matte Bronze x4',
        sku: '19-224',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/14-inch/gtw-14-bravo-bronze-300x300.jpg`,
        price: 320.00,
        retailPrice: 150.00,
        linkedProducts: [BlkLugnut],
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/070a40b2-e626-4dc2-502b-7b1eea243f00'
    },
    {
        id: 12,
        refId: 14,
        name: '14" GTW Bravo - Matte Gray x4',
        sku: '19-225',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/14-inch/gtw-14-bravo-mattegray-1-300x300.jpg`,
        price: 320.00,
        retailPrice: 150.00,
        linkedProducts: [BlkLugnut],
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/2efae1d0-0a50-4930-5f62-4af2f9225c00'
    },
    {
        id: 13,
        refId: 14,
        name: '14" GTW Bravo - Matte Black x4',
        sku: '19-251',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/14-inch/gtw-14-bravo-matteblack-1-300x300.jpg`,
        price: 320.00,
        retailPrice: 150.00,
        linkedProducts: [BlkLugnut],
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/80725b98-ed22-42f8-27dc-b78edbb4ca00',
        visible: false
    },
    {
        id: 14,
        refId: 14,
        name: '14" GTW Raven - Matte Black with Ball Mill x4',
        sku: '19-226',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/14-inch/gtw-14-raven-blackmachined-300x300.jpg`,
        price: 320.00,
        retailPrice: 150.00,
        linkedProducts: [BlkLugnut],
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/b8f02fb7-fb9c-4321-9348-791830903d00',
        visible: false
    },
    {
        id: 15,
        refId: 14,
        name: '14" GTW Vortex 2 - Matte Black x4',
        sku: '19-229',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/14-inch/gtw-14-vortex-blackmatte-300x300.jpg`,
        price: 320.00,
        retailPrice: 150.00,
        linkedProducts: [BlkLugnut],
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/94cb96e9-f825-4793-7669-46c74be6a300',
        visible: false
    },
    {
        id: 16,
        refId: 14,
        name: '14" GTW Vortex 2 - Matte Black with Machined Accent x4',
        sku: '19-230',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/14-inch/gtw-14-vortex-blackmachined-1-300x300.jpg`,
        price: 280.00,
        retailPrice: 150.00,
        linkedProducts: [ChromeLugnut],
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/829771f6-3f12-4196-40dd-8ae610655200'
    },
]

const Wheels14InLiftedX4: Product[] = [
    {
        id: 7,
        refId: 14,
        name: '14" GTW Specter - Chrome x4',
        sku: '19-190',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/14-inch/gtw-14-specter-chrome-1-300x300.jpg`,
        price: 440.00,
        retailPrice: 330.00,
        linkedProducts: [ChromeLugnut],
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/5db84926-f64d-4bdf-e0b9-62e14e0c9400'
    },
    {
        id: 8,
        refId: 14,
        name: '14" GTW Spyder - Black with Machined Accents x4',
        sku: '19-221',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/14-inch/gtw-14-spyder-blackmachined-300x300.jpg`,
        price: 280.00,
        retailPrice: 150.00,
        linkedProducts: [ChromeLugnut],
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/c67fc1e7-ed1b-4d5e-3e5c-f44e47b12b00',
        visible: false
    },
    {
        id: 9,
        refId: 14,
        name: '14" GTW Spyder - Matte Black x4',
        sku: '19-245',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/14-inch/gtw-14-spyder-matteblack-1-300x300.jpg`,
        price: 320.00,
        retailPrice: 150.00,
        linkedProducts: [BlkLugnut],
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/83ca7e3f-9a2a-40d5-fa60-546cb60a7000',
        visible: false
    },
    {
        id: 10,
        refId: 14,
        name: '14" GTW Spyder - Matte Gray x4',
        sku: '19-253',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/14-inch/gtw-14-spyder-matteblack-1-300x300.jpg`,
        price: 320.00,
        retailPrice: 150.00,
        linkedProducts: [BlkLugnut],
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/44c2212f-7734-47a4-6f61-50fcba2cfa00'
    },
    {
        id: 11,
        refId: 14,
        name: '14" GTW Bravo - Matte Bronze x4',
        sku: '19-224',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/14-inch/gtw-14-bravo-bronze-300x300.jpg`,
        price: 320.00,
        retailPrice: 150.00,
        linkedProducts: [BlkLugnut],
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/dedb3555-0ec6-44e4-3686-0a0bd57c2d00'
    },
    {
        id: 12,
        refId: 14,
        name: '14" GTW Bravo - Matte Gray x4',
        sku: '19-225',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/14-inch/gtw-14-bravo-mattegray-1-300x300.jpg`,
        price: 320.00,
        retailPrice: 150.00,
        linkedProducts: [BlkLugnut],
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/55e2481b-d53c-436b-809d-a44d28887500'
    },
    {
        id: 13,
        refId: 14,
        name: '14" GTW Bravo - Matte Black x4',
        sku: '19-251',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/14-inch/gtw-14-bravo-matteblack-1-300x300.jpg`,
        price: 320.00,
        retailPrice: 150.00,
        linkedProducts: [BlkLugnut],
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/ea9c391f-1697-4453-a499-8f0df4eef600',
        visible: false
    },
    {
        id: 14,
        refId: 14,
        name: '14" GTW Raven - Matte Black with Ball Mill x4',
        sku: '19-226',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/14-inch/gtw-14-raven-blackmachined-300x300.jpg`,
        price: 320.00,
        retailPrice: 150.00,
        linkedProducts: [BlkLugnut],
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/50772731-1a89-4022-8b06-29a9e95b8400',
        visible: false
    },
    {
        id: 15,
        refId: 14,
        name: '14" GTW Vortex 2 - Matte Black x4',
        sku: '19-229',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/14-inch/gtw-14-vortex-blackmatte-300x300.jpg`,
        price: 320.00,
        retailPrice: 150.00,
        linkedProducts: [BlkLugnut],
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/1de34626-0599-4de7-ebdf-0564a755d900',
        visible: false
    },
    {
        id: 16,
        refId: 14,
        name: '14" GTW Vortex 2 - Matte Black with Machined Accent x4',
        sku: '19-230',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/14-inch/gtw-14-vortex-blackmachined-1-300x300.jpg`,
        price: 280.00,
        retailPrice: 150.00,
        linkedProducts: [ChromeLugnut],
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/c38ffe89-7df2-420d-7734-719ee416a700'
    },
]

const Wheels15InX4: Product[] = [
    {
        id: 17,
        refId: 15,
        name: '15" MadJax® Flow Form Evolution - Matte Black x4',
        sku: '19-262',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/15-inch/madjax-15-flowform-matteblack-300x300.jpg`,
        price: 360.00,
        retailPrice: 260.00,
        linkedProducts: [BlkLugnut],
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/5fa7f3be-488a-4d74-c4bb-4f4dd02e1f00'
    },
    {
        id: 18,
        refId: 15,
        name: '15" MadJax® Flow Form Evolution - Gunmetal x4',
        sku: '19-264',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/15-inch/madjax-15-flowform-gunmetal-300x300.jpg`,
        price: 360.00,
        retailPrice: 260.00,
        linkedProducts: [BlkLugnut],
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/237d092e-9b3b-4f56-8fb0-529d7192a700'
    },
    {
        id: 19,
        refId: 15,
        name: '15" GTW Bravo - Matte Black x4',
        sku: '19-300',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/15-inch/gtw-15-bravo-matteblack-1-300x300.jpg`,
        price: 360.00,
        retailPrice: 260.00,
        linkedProducts: [BlkLugnut],
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/b28ed984-4fb0-4b30-62c4-ec3dbeac1b00'
    },
    {
        id: 20,
        refId: 15,
        name: '15" GTW Bravo - Matte Gray x4',
        sku: '19-302',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/15-inch/gtw-15-bravo-mattegray-1-300x300.jpg`,
        price: 360.00,
        retailPrice: 260.00,
        linkedProducts: [BlkLugnut],
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/daa1154a-24ef-463e-7c4a-63167b842a00'
    },
    {
        id: 21,
        refId: 15,
        name: '15" GTW Spyder - Gloss Black with Machined Accents x4',
        sku: '19-306',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/15-inch/gtw-15-spyder-blackmachined-300x300.jpg`,
        price: 320.00,
        retailPrice: 260.00,
        linkedProducts: [ChromeLugnut],
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/b77cc238-6c29-4e29-335d-cca2f32bab00'
    },
    {
        id: 22,
        refId: 15,
        name: '15" GTW Spyder - Matte Black x4',
        sku: '19-307',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/15-inch/gtw-15-spyder-matteblack-1-300x300.jpg`,
        price: 320.00,
        retailPrice: 260.00,
        linkedProducts: [BlkLugnut],
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/a7d8acbe-c828-4afe-f054-1b1e75f9c000'
    },
]


export { 
    Wheels12InX2, 
    Wheels12InLiftedX2,
    Wheels14InX2, 
    Wheels14InLiftedX2,
    Wheels15InX2,
    Wheels12InX4, 
    Wheels12InLiftedX4,
    Wheels14InX4, 
    Wheels14InLiftedX4,
    Wheels15InX4,
    WheelSizeOptions
}